import { store } from '../store'

// Takovýhle prasárny se musej urdžovat v separátních souborech a importovat dynamicky,
// jinak dělaj velmi jednoduše circular dependencies
export function getAccessToken(): string {
  return store.getState().user?.info?.accessToken || ''
}
